import { createFileRoute } from '@tanstack/react-router';
import { InboxPage } from '@web/modules/conversations/inbox/inbox-page';
import { parseInboxSearch } from '@web/modules/conversations/inbox/inbox-search';

export const Route = createFileRoute('/_app/conversations')({
  validateSearch: (search: Record<string, unknown>) => parseInboxSearch(search),
  component: ConversationsRoute,
});

function ConversationsRoute() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <InboxPage
      search={search}
      onSearchChange={(next, options) => void navigate({ search: next, replace: options?.replace })}
    />
  );
}
